import { useState } from 'react';
import { useDiscipleStore } from '../../../../../store/discipleStore';
import { createDisciple, getDisciples } from '../apis/disciple-apis';
import { Disciple } from '../types/disciple';

/**
 * 제자 추가 관련 로직을 관리하는 커스텀 훅
 */
export const useAddDisciple = () => {
  const { setDisciples } = useDiscipleStore();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string>('');

  /**
   * 제자 추가 및 DB 동기화
   * @param disciple 추가할 제자 데이터
   * @param onSuccess 추가 성공 시 호출할 콜백 (폼 초기화 등)
   */
  const addDisciple = async (disciple: Disciple, onSuccess?: () => void) => {
    if (isLoading) return;

    setIsLoading(true);
    setError('');

    try {
      // DB에 제자 추가
      await createDisciple(disciple);

      // DB에서 최신 리스트 가져오기
      const updatedDisciples = await getDisciples();

      // 스토어 업데이트
      setDisciples(updatedDisciples);

      // 성공 콜백 실행 (폼 초기화 등)
      onSuccess?.();
    } catch (err) {
      const errorMessage = '제자 추가 중 오류가 발생했습니다. 다시 시도해주세요.';
      console.error('제자 추가 중 오류 발생:', err);
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    addDisciple,
    isLoading,
    error,
    clearError: () => setError(''),
  };
};
